module.exports = __webpack_public_path__ + "img/sdv.fc9f9974.png";